import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = localStorage.getItem('token');

    if (!token || this.isTokenExpired(token)) {
      this.router.navigate(['/welcome']); 
      return false;
    }

    return true; 
  }

  private isTokenExpired(token: string): boolean {
    try {
      const payload = token.split('.')[1]; 
      const decodedPayload = JSON.parse(atob(payload)); 
      const currentTime = Math.floor(new Date().getTime() / 1000); 

      return decodedPayload.exp < currentTime; // Retorna true si el token ya expiró
    } catch (error) {
      return true; 
    }
  }
}
